<script>
  import { errorState, errorMessage } from './services/stores.js'
  import { Alert, Container, Row, Col } from '@sveltestrap/sveltestrap'

  import { _ } from 'svelte-i18n'

  function clearError () {
    $errorState = false
  }

</script>
{#if $errorState}
  <Container class="mt-2">
    <Row>
      <Col class="col-6 col-sm-7 col-md-9" />
      <Col class="col-6 col-sm-5 col-md-3">
        <Alert color="danger" isOpen={$errorState} toggle={clearError}>
          <h5>{$_('error.error')}</h5>
          {$errorMessage}
        </Alert>
      </Col>
    </Row>
  </Container>
{/if}
